<template>
    <div v-if="operador" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Operador de Pagamento</h4>
        <router-link to="/financeiro/parametros/operadores">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <!-- Seção de Detalhes -->
        <FormSection title="">
          <p><strong>Operador:</strong> {{ operador.operador || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ verificarAtivo(operador?.ativo) }}</p>
          <p><strong>Criado em:</strong> {{ formatarData(operador?.criado_em) }}</p>
          <p><strong>Atualizado em:</strong> {{ formatarData(operador?.atualizado_em) }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        operador: null,
      };
    },
    methods: {
      async carregarDetalhesOperador() {
        try {
          const response = await axios.get(
            `/financeiro/parametros/operadores/${this.$route.params.id}`
          );
          this.operador = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes do operador:", error);
        }
      },
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          return "Não informado";
        }
        return valor ? "Ativo" : "Inativo";
      },
      formatarData(data) {
        if (!data) return "Não informado";
        return new Date(data).toLocaleString();
      },
    },
    mounted() {
      this.carregarDetalhesOperador();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  